import React from 'react';
import Item from './item';

const Localnav = (props) => {
  if (!props.Menu) return null;

  const firstLevel = props.Menu.map((menuItem, index) => {
    return <Item key={index} {...menuItem} />;
  });

  return (
    <nav className="c-localnav">
      <h2 className="c-localnav__heading">
        <a href={props.Ancestor.Url}>{props.Ancestor.Name}</a>
      </h2>

      <ul className="c-localnav__list">{firstLevel}</ul>
    </nav>
  );
};

export default Localnav;
